export default __webpack_public_path__ + "0ff548b24adcc050e14d5589852997bd.jpg";